<div class="d-flex info-list-item" [ngClass]="{ 'freemium' : showFreemiumLock }">
  <div class="label">
    <ng-container *ngIf="tooltipText">
      <a class="btn btn-link help-icon py-0 pl-0" data-animation="false" data-placement="top" data-toggle="tooltip"
        title="{{tooltipText}}" style="cursor: pointer;">
        <img src="/assets/images/icon-indicator-info-2.svg" alt="Info Icon" />
      </a>
    </ng-container>

    <ng-container *ngIf="sectionLink">
      <a class="btn btn-link help-icon" (click)="goToSection()">
        {{label}}
      </a>
    </ng-container>
    <ng-container *ngIf="!sectionLink">
      {{label}}
    </ng-container>

  </div>
  <div class="value ml-2">

    <ng-container *ngIf="showFreemiumLock">
      <div class="freemium-lock">
        <i class="fa fa-lock"></i>
      </div>
    </ng-container>

    <ng-container *ngIf="!showFreemiumLock">
      <ng-container *ngIf="canRouteToDiscovery">
        <a [routerLink]="discoveryRouteLink" [queryParams]="discoveryQueryParams">
          <img title="{{value}}" src="{{icon}}" alt="{{value}} Icon" *ngIf="icon" width="16" height="16" />
          <ng-container *ngIf="!type">
            {{value}}
          </ng-container>
          <ng-container *ngIf="type === 'percent'">
            {{value | perc:'1.2-2'}}
          </ng-container>
          <ng-container *ngIf="type === 'num'">
            {{value | num}}
          </ng-container>
          <ng-container *ngIf="type === 'roundsig'">
            {{value | roundsig}}
          </ng-container>
          <ng-container *ngIf="type === 'risk'">
            <risk-heat-meter [risk]='value'></risk-heat-meter>
          </ng-container>
          <ng-container *ngIf="type === 'text-risk'">
            {{text}}
            <risk-heat-meter [risk]='value'></risk-heat-meter>
          </ng-container>
        </a>
      </ng-container>

      <ng-container *ngIf="!canRouteToDiscovery">
        <ng-container *ngIf="!type">
          {{value}}
        </ng-container>
        <ng-container *ngIf="type === 'link'">
          <ng-container *ngIf="(!value || value === 'N/A'); else showLink">
            N/A
          </ng-container>
          <ng-template #showLink>
            <a class="btn btn-link p-0 external-link" target="_blank" href="{{value | urlfix}}">
              <span>{{value}} </span><i class="fa fa-external-link"></i>
            </a>
          </ng-template>
        </ng-container>
        <ng-container *ngIf="type === 'percent'">
          {{value | perc:'1.2-2'}}
        </ng-container>
        <ng-container *ngIf="type === 'num'">
          {{value | num}}
        </ng-container>
        <ng-container *ngIf="type === 'roundsig'">
          {{value | roundsig}}
        </ng-container>
        <ng-container *ngIf="type === 'risk'">
          <risk-heat-meter [risk]='value'></risk-heat-meter>
        </ng-container>
        <ng-container *ngIf="type === 'text-risk'">
          {{text}}
          <risk-heat-meter [risk]='value'></risk-heat-meter>
        </ng-container>
        <ng-container *ngIf="type === 'comma-list'">
          <ng-container *ngFor="let cat of value; let i = index;">
            <span *ngIf="i > 0">, </span>
            {{cat}}
          </ng-container>
        </ng-container>
        <ng-container *ngIf="type === 'yesno'">
          <img class="mr-1" src="/assets/images/icon-indicator-{{value ? 'yes' : 'no'}}-2.svg"
            alt="{{value ? 'Yes' : 'No'}} Icon" />
          <span class="text-capitalize">{{value ? 'yes' : 'no'}}</span>
        </ng-container>
        <ng-container *ngIf="type === 'yesnorev'">
          <img class="mr-1" src="/assets/images/icon-indicator-{{value ? 'no' : 'yes'}}-2.svg"
            alt="{{value ? 'Yes' : 'No'}} Icon">
          <span class="text-capitalize">{{value ? 'yes' : 'no'}}</span>
        </ng-container>
      </ng-container>

    </ng-container>
  </div>
</div>
